module.exports = __webpack_public_path__ + "img/box.3da3079f.png";